import { render, staticRenderFns } from "./SkeletonGenerator.vue?vue&type=template&id=649d8827&scoped=true"
import script from "./SkeletonGenerator.vue?vue&type=script&lang=js"
export * from "./SkeletonGenerator.vue?vue&type=script&lang=js"
import style0 from "./SkeletonGenerator.vue?vue&type=style&index=0&id=649d8827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_lodash@4.17.21_prettier@3.5.3_react@19.0.0_vue-template-c_l4y5rdbexcxjh5nqfbzyfvj2aq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d8827",
  null
  
)

export default component.exports